import { takeLatest, put, select } from 'redux-saga/effects'
import { toast } from '../../components/Toast'

import {
  claimBonus,
  cancelBonus,
  getAllBonus, getBonusDetail, getUserBonus, availBonus, getLoyaltyLevel, getLoyaltyDetails, getCashbackTable
} from '../../utils/apiCalls'

import {
  getAllBonusStart,
  getAllBonusSuccess,
  getAllBonusFailure,
  getBonusDetailStart,
  getBonusDetailSuccess,
  getBonusDetailFailure,
  claimBonusStart,
  claimBonusComplete,
  getUserBonusStart,
  getUserBonusSuccess,
  getUserBonusFailure,
  cancelBonusStart,
  cancelBonusComplete,
  availBonusStart,
  availBonusComplete,
  getLoyaltyLevelStart,
  getLoyaltyLevelSuccess,
  getLoyaltyLevelFailure,
  getLoyaltyDetailsStart,
  getLoyaltyDetailsSuccess,
  getLoyaltyDetailsFailure,
  getWageringBarStart,
  getWageringBarSuccess,
  getWageringBarFailure,
  getDepositUserBonusSuccess,
  getCashbackTableStart,
  getCashbackTableSuccess,
  getCashbackTableFailure,
  getUserActiveBonusStart,
  getUserActiveBonusSuccess,
  getUserActiveBonusFailure,
  getUserBonusReset,
  getUserActiveBonusReset,
  forfeitBonusStart,
  forfeitBonusSuccess,
  forfeitBonusFailure,
  getUserComingBonusSuccess,
  getUserComingActiveBonusReset,
  getUserComingActiveBonusStart
} from '../redux-slices/bonus'
import { showFooter } from '../redux-slices/loader'
import { killAllFrames } from '../../utils/helpers'
import { BONUS_STATUS } from 'utils/constants'
import { formatToDepositCompatibleBonusObject } from 'utils/bonus'
import { isSportsFreebetBonus } from 'utils/bonusUtils'
import { BONUS_FROM } from 'constants/bonus'

export default function * bonusWatcher () {
  yield takeLatest(getAllBonusStart.type, getAllBonusWorker)
  yield takeLatest(getBonusDetailStart.type, getBonusDetailWorker)
  yield takeLatest(claimBonusStart.type, claimBonusWorker)
  yield takeLatest(getUserBonusStart.type, getUserBonusWorker)
  yield takeLatest(getUserActiveBonusStart.type, getUserActiveBonusWorker)
  yield takeLatest(getUserComingActiveBonusStart.type, getUserActiveBonusWorker)
  yield takeLatest(cancelBonusStart.type, cancelBonusWorker)
  yield takeLatest(availBonusStart.type, availBonusWorker)
  yield takeLatest(getLoyaltyLevelStart.type, getLoyaltyLevelWorker)
  yield takeLatest(getLoyaltyDetailsStart.type, getLoyaltyDetailsWorker)
  yield takeLatest(getWageringBarStart.type, getWageringBarWorker)
  yield takeLatest(getCashbackTableStart.type, getCashbackTableWorker)
  yield takeLatest(forfeitBonusStart.type, forfeitBonusWorker)
}

const showLoaderValues = (state) => state?.loader
const selectedLangCode = (state) => state?.language
const getLanguageData = (state) => state.language.languageData


function * getAllBonusWorker (action) {
  try {
    const { showHeader, showChildren } = yield select(showLoaderValues)
    const { limit, pageNo, bonusType } = action && action.payload
    const { data } = yield getAllBonus({ limit, pageNo, bonusType })

    yield put(getAllBonusSuccess(data?.data?.bonus))

    showHeader && showChildren && (yield put(showFooter(true)))
  } catch (e) {
    yield put(getAllBonusFailure())
  }
}

function * getBonusDetailWorker (action) {
  const { bonusId, navigate, userBonusId = '' } = action && action.payload
  const { selectedLanguageCode } = yield select(selectedLangCode)
  try {
    const { showHeader, showChildren } = yield select(showLoaderValues)
    const isNumber = !isNaN(bonusId);

    const params = isNumber
      ? { bonusId, userBonusId }
      : { slug: bonusId, userBonusId };

    const { data } = yield getBonusDetail(params)

    yield put(getBonusDetailSuccess({ bonusDetails: data?.data?.bonusDetails, params }))

    showHeader && showChildren && (yield put(showFooter(true)))
  } catch (e) {
    const failurePayload = {}

    if (e?.response?.data?.errors[0]?.errorCode && typeof navigate === 'function') {
      navigate(`/${(selectedLanguageCode?.toLowerCase())}/promotion`)
    }
    yield put(getBonusDetailFailure(failurePayload))
  }
}

function * claimBonusWorker (action) {
  try {
    const { selectedLanguageCode } = yield select(selectedLangCode)
    const { data, bonusDetail, navigate } = action && action.payload
    const res = yield claimBonus(data)

    if (!['balance'].includes(bonusDetail.bonusType)) {
      const bonusData = res?.data?.data?.createBonus

      bonusData.bonus = {
        currency: bonusDetail?.currency,
        promotionTitle: bonusDetail?.promotionTitle,
        depositBonusPercent: bonusDetail?.depositBonusPercent
      }
      navigate(`/${(selectedLanguageCode?.toLowerCase())}/account/dashboard`)
    }

    yield put(claimBonusComplete())

    yield put(getBonusDetailStart({ bonusId: data.bonusId }))
    yield toast(res?.data?.data?.message, 'success')
  } catch (e) {
    const { selectedLanguageCode } = yield select(selectedLangCode)
    const { bonusDetail, navigate } = action && action.payload

    yield put(claimBonusComplete())

    if (e?.response?.data?.errors[0]?.errorCode !== 3066) {
      navigate(`/${(selectedLanguageCode?.toLowerCase())}/account/dashboard`, { state: { tab: 'dashboard', bonusDetail } })
    }

    yield toast(e?.response?.data?.errors[0]?.description, 'error')
  }
}

function * getUserBonusWorker (action) {
  try {
    const { limit, pageNo, status, inDeposit = '' } = action && action.payload

    const { data } = yield getUserBonus({ limit, pageNo, status, ...(inDeposit ? { inDeposit } : {}) })
    if (inDeposit) {
      yield put(getDepositUserBonusSuccess(data?.data?.userBonus))
    } else {
      if (pageNo === 1) {
        yield put(getUserBonusReset())
      }
      yield put(getUserBonusSuccess(data?.data?.userBonus))
    }
  } catch (e) {
    yield put(getUserBonusFailure())
  }
}

function * cancelBonusWorker (action) {
  try {
    const {
      data, setBonusPageNo, status, activeBonuses, duplicateHandler = false,
      deposit = false, handleSubmit
    } = action && action.payload
    yield cancelBonus({ data })
    yield put(cancelBonusComplete())
    typeof handleSubmit === 'function' && handleSubmit()
    if (duplicateHandler) {
      duplicateHandler()
      killAllFrames()
    } else {
      if (deposit) {
        yield put(getUserBonusStart({
          limit: '',
          pageNo: '',
          status: JSON.stringify(status),
          inDeposit: true
        }))
      } else if (data?.bonusStatus) {
        if ([BONUS_STATUS.ACTIVE].includes(data?.bonusStatus)) {
          yield put(getUserActiveBonusStart({
            limit: 8,
            pageNo: 1,
            status: JSON.stringify([BONUS_STATUS.ACTIVE, BONUS_STATUS.RESERVED])
          }))
        } else yield put(getUserComingActiveBonusStart({ limit: 8, pageNo: 1, status: JSON.stringify([BONUS_STATUS.PENDING]), upComingBonus: true }))
      } else {
        if (typeof setBonusPageNo === 'function') {
          setBonusPageNo(1)
        }
        yield put(getUserBonusStart({ limit: 6, pageNo: 1, status }))
        yield put(getUserActiveBonusReset())
        yield put(getUserActiveBonusSuccess(activeBonuses))
      }
    }
  } catch (e) {
    yield toast(e?.response?.data?.errors[0]?.description, 'error')
    yield put(cancelBonusComplete())
  }
}

function * availBonusWorker (action) {
  const languageData = yield select(getLanguageData)
  try {
    const { selectedLanguageCode } = yield select(selectedLangCode)
    const { data, bonusType, bonusAmount, item, navigate, setShowFreeSpinGameModal, currencyCode, identifier, from = '', getBonusDetailAfterAvail = false, bonusId = '' } = action && action.payload
    yield availBonus({ data })
    const isZeroDeposit = (['match', 'manual'].includes(item?.bonusType)) && ((item?.currency && item?.currency[currencyCode]?.minDeposit === '0') || (item?.bonus?.currency && item?.bonus?.currency[currencyCode]?.minDeposit === '0'))
    if (!['deposit', 'wagering', 'balance'].includes(bonusType) && !bonusAmount && !data?.inDeposit) {
      const bonusDetail = from === BONUS_FROM.BONUS_DETAIL ? formatToDepositCompatibleBonusObject(item, selectedLanguageCode?.toUpperCase()) : item
      if (isSportsFreebetBonus(item)) {
        navigate(`/${(selectedLanguageCode?.toLowerCase())}/account/dashboard`, { state: { tab: 'dashboard' } })
      } else if (item?.bonusType === 'freespins') {
        if ((item?.currency && item?.currency[currencyCode]?.minDeposit !== '0') || (item?.bonus?.currency && item?.bonus?.currency[currencyCode]?.minDeposit !== '0')) {
          navigate(`/${(selectedLanguageCode?.toLowerCase())}/account/deposit`, { state: { tab: 'deposit', bonusDetail, identifier } })
        } else {
          // No deposit required for Free Spins bonus
          navigate(`/${(selectedLanguageCode?.toLowerCase())}/account/dashboard`, { state: { tab: 'dashboard' } })
        }
      } else {
        // If Zero Deposit bonus don't navigate
        !isZeroDeposit && navigate(`/${(selectedLanguageCode?.toLowerCase())}/account/deposit`, { state: { tab: 'deposit', bonusDetail } })
      }
    } else {
      // For Match and Manual Bonus with Minimum Deposit (0) Required navigate to Dashboard
      if (['match', 'match_1', 'manual', 'manual_1'].includes(item?.bonusType) && item?.minimumDepositRequired) {
        navigate(`/${(selectedLanguageCode?.toLowerCase())}/account/dashboard`, { state: { tab: 'dashboard' } })
      }
    }
    if (setShowFreeSpinGameModal) {
      setShowFreeSpinGameModal(false)
    }
    if (from !== 'deposit') {
      yield put(getUserActiveBonusStart({ limit: 8, pageNo: 1, status: JSON.stringify([BONUS_STATUS.ACTIVE, BONUS_STATUS.RESERVED]) }))
      yield put(getUserComingActiveBonusStart({ limit: 8, pageNo: 1, status: JSON.stringify([BONUS_STATUS.PENDING]), upComingBonus: true }))
    } else {
      yield put(getUserBonusStart({
        limit: '',
        pageNo: '',
        status: JSON.stringify([BONUS_STATUS.PENDING]),
        inDeposit: true
      }))
    }

    yield put(availBonusComplete())

    if (getBonusDetailAfterAvail) {
      yield put(getBonusDetailStart({ bonusId, userBonusId: data?.userBonusId }))
    }
  } catch (e) {
    const { selectedLanguageCode } = yield select(selectedLangCode)
    const { data, setShowLapsedModal, navigate } = action && action.payload

    yield put(availBonusComplete())

    if (e?.response?.data?.errors[0]?.errorCode === 3072) {
      setShowLapsedModal(true)
    } else {
      yield toast(languageData?.alreadyActiveBonus || e?.response?.data?.errors[0]?.description, 'error')

      data?.inDeposit && navigate(`/${(selectedLanguageCode?.toLowerCase())}/account/dashboard`, { state: { tab: 'dashboard' } })
    }
  }
}

function * getLoyaltyLevelWorker () {
  try {
    const { data } = yield getLoyaltyLevel()

    yield put(getLoyaltyLevelSuccess(data?.data?.loyaltyLevel))

    yield put(showFooter(true))
  } catch (e) {
    yield put(getLoyaltyLevelFailure())
  }
}

function * getLoyaltyDetailsWorker () {
  try {
    const { data } = yield getLoyaltyDetails()

    yield put(getLoyaltyDetailsSuccess(data?.data?.loyaltyDetails))
  } catch (e) {
    yield put(getLoyaltyDetailsFailure())
  }
}

function * getWageringBarWorker (action) {
  try {
    const { limit, pageNo, status } = action && action.payload

    const { data } = yield getUserBonus({ limit, pageNo, status })

    yield put(getWageringBarSuccess(data?.data?.userBonus?.rows?.[0] || {}))
  } catch (e) {
    yield put(getWageringBarFailure())
  }
}

function * getCashbackTableWorker () {
  try {
    const { data } = yield getCashbackTable()

    yield put(getCashbackTableSuccess(data?.data?.cashbackDetails))

    yield put(showFooter(true))
  } catch (e) {
    yield put(getCashbackTableFailure())
  }
}

function * getUserActiveBonusWorker (action) {
  try {
    const { limit, pageNo, status, upComingBonus = false, updateWageringBar = false } = action && action.payload
    const { data } = yield getUserBonus({ limit, pageNo, status })

    if (pageNo === 1) {
      !upComingBonus
        ? yield put(getUserActiveBonusReset())
        : yield put(getUserComingActiveBonusReset())
    }

    !upComingBonus
      ? yield put(getUserActiveBonusSuccess(data?.data?.userBonus))
      : yield put(getUserComingBonusSuccess(data?.data?.userBonus))

    if (updateWageringBar && !upComingBonus) {
      yield put(getWageringBarSuccess(data?.data?.userBonus?.rows?.[0] || {}))
    }
  } catch (e) {
    yield put(getUserActiveBonusFailure())
  }
}

function * forfeitBonusWorker (action) {
  try {
    const { data } = action && action.payload

    yield cancelBonus({ data })

    yield put(forfeitBonusSuccess())
  } catch (e) {
    yield put(forfeitBonusFailure())
  }
}
